import { config } from './config';
import { log } from './logger';

export const VITE_SUPABASE_URL    = config.supabaseUrl;
export const VITE_SUPABASE_ANON_KEY = config.supabaseAnonKey;

log.debug('[env.ts] Environment variables loaded:', {
  hasUrl: !!VITE_SUPABASE_URL,
  hasKey: !!VITE_SUPABASE_ANON_KEY,
  source: config.source,
});

if (!VITE_SUPABASE_URL) {
  log.warn('[env.ts] VITE_SUPABASE_URL is not set - Moloni integration will not work');
}

if (!VITE_SUPABASE_ANON_KEY) {
  log.warn('[env.ts] VITE_SUPABASE_ANON_KEY is not set - Moloni integration will not work');
}
